module.exports = __webpack_public_path__ + "static/media/memphis_pattern.19655d59.svg";